import { render } from "./LoginVerificationDialog.vue?vue&type=template&id=b38940c6"
import script from "./LoginVerificationDialog.vue?vue&type=script&lang=js"
export * from "./LoginVerificationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__